<template>
  <div>
    <logged-in-header />
    <vending-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import vendingPanel from "../components/vendings/VendingPanel.vue";

export default {
  components: {
    loggedInHeader,
    vendingPanel
  }
};
</script>
